import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Copy } from "@phosphor-icons/react/Copy";
import { DiscordLogo } from "@phosphor-icons/react/DiscordLogo";
import { FacebookLogo } from "@phosphor-icons/react/FacebookLogo";
import { LinkedinLogo } from "@phosphor-icons/react/LinkedinLogo";
import { PaperPlaneTilt } from "@phosphor-icons/react/PaperPlaneTilt";
import { RedditLogo } from "@phosphor-icons/react/RedditLogo";
import { TwitterLogo } from "@phosphor-icons/react/TwitterLogo";
import { X } from "@phosphor-icons/react/X";

const shareOptions = [
	{ icon: <Copy />, label: "Copy Link" },
	{ icon: <PaperPlaneTilt />, label: "Email" },
	{ icon: <LinkedinLogo />, label: "Share on Linkedin" },
	{ icon: <FacebookLogo />, label: "Share on Facebook" },
	{ icon: <TwitterLogo />, label: "Share on X" },
	{ icon: <RedditLogo />, label: "Share on Reddit" },
	{ icon: <DiscordLogo />, label: "Share on Discord" },
];

export const ShareFeatureDialog = ({ title, open, onClose }) => {
	return (
		<Dialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			sx={{
				"& .MuiDialog-container": { justifyContent: "center" },
				"& .MuiDialog-paper": { width: "100%" },
			}}>
			<DialogContent>
				<Stack
					direction="row"
					spacing={2}
					sx={{
						alignItems: "center",
						flex: "0 0 auto",
						justifyContent: "space-between",
						p: 2,
					}}>
					<Typography variant="h6">Share {title}</Typography>
					<IconButton onClick={onClose}>
						<X />
					</IconButton>
				</Stack>
				<Stack padding={2}>
					<List disablePadding>
						{shareOptions.map(({ icon, label }) => (
							<ListItem
								disablePadding
								key={label}>
								<ListItemButton>
									<ListItemIcon>{icon}</ListItemIcon>
									<ListItemText
										color="text.primary"
										primary={label}
									/>
								</ListItemButton>
							</ListItem>
						))}
					</List>
				</Stack>
			</DialogContent>
		</Dialog>
	);
};
